import { 
  WorkExecutionData, 
  ExecutionBatch, 
  WorkExecutionStatus, 
  ExecutionBatchStatus, 
  ExecutionUserRole,
  WorkExecutionWidgetData,
  ExecutionBatchWidgetData
} from "../types";

// Helper function to calculate age in days
const calculateAge = (date: string) => {
  const today = new Date();
  const targetDate = new Date(date);
  const timeDiff = today.getTime() - targetDate.getTime();
  return Math.floor(timeDiff / (1000 * 3600 * 24));
};

// Mock Work Execution Data
export const mockWorkExecutionData: WorkExecutionData[] = [
  {
    id: "WE001",
    workOrderId: "WO001",
    workOrderNumber: "WO/2025-26/HYD/0042",
    workOrderTitle: "Core & Shell - Tower B",
    siteId: "S001",
    siteName: "HYD Site A",
    projectId: "P001", 
    projectName: "Tower B",
    contractorId: "C001",
    contractorName: "Galaxy Infra",
    contractType: "Construction Work",
    workOrderOwner: "John Smith",
    plannedStartDate: "2025-08-10",
    plannedEndDate: "2026-02-15",
    actualStartDate: "2025-08-12",
    releasedOn: "2025-08-05",
    totalValue: 2237280,
    executedValue: 1342368,
    paidAmount: 1208131,
    retentionAmount: 67118,
    onHoldAmount: 0,
    outstandingAmount: 895149,
    progressPercentage: 60,
    status: WorkExecutionStatus.InProgress,
    executionBatches: [],
    executionLines: [
      {
        id: "EL001",
        workOrderLineId: "WOL001",
        lineNumber: "001",
        taskTitle: "Foundation Excavation", 
        taskDescription: "Excavation for foundation up to required depth",
        approvedQuantity: 1200,
        executedQuantity: 480,
        cumulativeExecuted: 720,
        remainingQuantity: 480,
        workCompletionPercentage: 60,
        rate: 850,
        executedValue: 612000,
        uom: "Cum",
        remarks: "Rock formation encountered - additional breaking work required",
        status: "In Progress"
      },
      {
        id: "EL002", 
        workOrderLineId: "WOL002",
        lineNumber: "002",
        taskTitle: "Concrete Pouring",
        taskDescription: "RCC concrete pouring for foundation",
        approvedQuantity: 800,
        executedQuantity: 320,
        cumulativeExecuted: 320,
        remainingQuantity: 480,
        workCompletionPercentage: 40,
        rate: 1200,
        executedValue: 384000,
        uom: "Cum", 
        remarks: "Waiting for foundation excavation completion",
        status: "Pending"
      }
    ],
    createdAt: "2025-08-01T10:30:00Z",
    createdBy: "John Smith",
    updatedAt: "2025-08-22T14:45:00Z",
    lastExecutionDate: "2025-08-20",
    lastExecutionUpdate: "2025-08-22T09:30:00Z"
  },
  {
    id: "WE002", 
    workOrderId: "WO002",
    workOrderNumber: "WO/2025-26/BLR/0018",
    workOrderTitle: "MEP Package",
    siteId: "S002",
    siteName: "BLR Site C",
    projectId: "P003",
    projectName: "Tower C",
    contractorId: "C002",
    contractorName: "Zenith MEP",
    contractType: "Construction Work",
    workOrderOwner: "Mike Johnson",
    plannedStartDate: "2025-09-01",
    plannedEndDate: "2026-05-31",
    actualStartDate: "2025-09-03",
    releasedOn: "2025-08-25",
    totalValue: 3450000,
    executedValue: 2415000,
    paidAmount: 2173500,
    retentionAmount: 120750,
    onHoldAmount: 0,
    outstandingAmount: 1035000,
    progressPercentage: 70,
    status: WorkExecutionStatus.InProgress,
    executionBatches: [],
    executionLines: [
      {
        id: "EL003",
        workOrderLineId: "WOL003",
        lineNumber: "001",
        taskTitle: "HVAC Installation",
        taskDescription: "5-star energy rated HVAC system installation",
        approvedQuantity: 15,
        executedQuantity: 8,
        cumulativeExecuted: 8,
        remainingQuantity: 7,
        workCompletionPercentage: 53,
        rate: 150000,
        executedValue: 1200000,
        uom: "Nos",
        remarks: "VRV units installed, pending commissioning",
        status: "In Progress"
      },
      {
        id: "EL004",
        workOrderLineId: "WOL004", 
        lineNumber: "002",
        taskTitle: "Electrical Distribution",
        taskDescription: "Main electrical distribution panels - 1500 KVA",
        approvedQuantity: 3,
        executedQuantity: 2,
        cumulativeExecuted: 2,
        remainingQuantity: 1,
        workCompletionPercentage: 67,
        rate: 500000,
        executedValue: 1000000,
        uom: "Nos",
        remarks: "Main panels installed, testing in progress",
        status: "In Progress"
      }
    ],
    createdAt: "2025-08-25T09:15:00Z",
    createdBy: "Mike Johnson",
    updatedAt: "2025-08-22T16:30:00Z",
    lastExecutionDate: "2025-08-21",
    lastExecutionUpdate: "2025-08-22T11:15:00Z"
  },
  {
    id: "WE003",
    workOrderId: "WO003", 
    workOrderNumber: "WO/2025-26/CHN/0025",
    workOrderTitle: "Foundation Work Package",
    siteId: "S003",
    siteName: "Chennai Site D",
    projectId: "P004",
    projectName: "Residential Complex",
    contractorId: "C003",
    contractorName: "L&T Civil Infra",
    contractType: "Construction Work",
    workOrderOwner: "Sarah Wilson",
    plannedStartDate: "2025-09-05",
    plannedEndDate: "2025-12-15",
    actualStartDate: "2025-09-07",
    releasedOn: "2025-08-30",
    totalValue: 2124000,
    executedValue: 0,
    paidAmount: 0,
    retentionAmount: 0,
    onHoldAmount: 0,
    outstandingAmount: 2124000,
    progressPercentage: 0,
    status: "Pending Approvals" as any,
    executionBatches: [],
    executionLines: [
      {
        id: "EL005",
        workOrderLineId: "WOL005",
        lineNumber: "001",
        taskTitle: "Site Preparation",
        taskDescription: "Site clearing and preparation work", 
        approvedQuantity: 1000,
        executedQuantity: 150,
        cumulativeExecuted: 150,
        remainingQuantity: 850,
        workCompletionPercentage: 15,
        rate: 125,
        executedValue: 18750,
        uom: "Sqm",
        remarks: "Initial site preparation started, pending approval for next phase",
        status: "Pending"
      }
    ],
    createdAt: "2025-08-10T11:20:00Z",
    createdBy: "Sarah Wilson",
    updatedAt: "2025-08-23T10:15:00Z",
    lastExecutionDate: "2025-08-22",
    lastExecutionUpdate: "2025-08-23T08:30:00Z"
  },
  {
    id: "WE004",
    workOrderId: "WO004",
    workOrderNumber: "WO/2025-26/DEL/0012", 
    workOrderTitle: "Interior Finishing Work",
    siteId: "S004",
    siteName: "Delhi Office Complex",
    projectId: "P005",
    projectName: "Corporate Headquarters",
    contractorId: "C004",
    contractorName: "Elite Interiors Ltd",
    contractType: "Service",
    workOrderOwner: "Robert Taylor",
    plannedStartDate: "2025-07-01",
    plannedEndDate: "2025-12-31",
    actualStartDate: "2025-07-03",
    actualEndDate: "2025-12-20",
    releasedOn: "2025-06-25",
    totalValue: 4200000,
    executedValue: 4200000,
    paidAmount: 3990000,
    retentionAmount: 210000,
    onHoldAmount: 0,
    outstandingAmount: 0,
    progressPercentage: 100,
    status: WorkExecutionStatus.Closed,
    executionBatches: [],
    executionLines: [
      {
        id: "EL006",
        workOrderLineId: "WOL006",
        lineNumber: "001",
        taskTitle: "False Ceiling Work",
        taskDescription: "Gypsum board false ceiling with lighting fixtures",
        approvedQuantity: 2500,
        executedQuantity: 2500,
        cumulativeExecuted: 2500,
        remainingQuantity: 0,
        workCompletionPercentage: 100,
        rate: 850,
        executedValue: 2125000,
        uom: "Sqft",
        remarks: "Completed as per specifications",
        status: "Completed"
      },
      {
        id: "EL007",
        workOrderLineId: "WOL007", 
        lineNumber: "002",
        taskTitle: "Flooring Work",
        taskDescription: "Vitrified tile flooring in office areas",
        approvedQuantity: 3000,
        executedQuantity: 3000,
        cumulativeExecuted: 3000,
        remainingQuantity: 0,
        workCompletionPercentage: 100,
        rate: 450,
        executedValue: 1350000,
        uom: "Sqft",
        remarks: "Completed with premium grade tiles",
        status: "Completed"
      }
    ],
    createdAt: "2025-06-25T08:45:00Z",
    createdBy: "Robert Taylor",
    updatedAt: "2025-12-20T17:30:00Z",
    lastExecutionDate: "2025-12-20",
    lastExecutionUpdate: "2025-12-20T17:30:00Z"
  },
  {
    id: "WE005",
    workOrderId: "WO005",
    workOrderNumber: "WO/2025-26/MUM/0033",
    workOrderTitle: "Structural Repairs - Block A",
    siteId: "S005",
    siteName: "Mumbai Industrial Site", 
    projectId: "P006",
    projectName: "Warehouse Complex",
    contractorId: "C005",
    contractorName: "Repair Specialists Ltd",
    contractType: "Maintenance",
    workOrderOwner: "David Brown",
    plannedStartDate: "2025-08-15",
    plannedEndDate: "2025-11-15",
    actualStartDate: "2025-08-18",
    releasedOn: "2025-08-10",
    totalValue: 1850000,
    executedValue: 925000,
    paidAmount: 0,
    retentionAmount: 0,
    onHoldAmount: 0,
    outstandingAmount: 1850000,
    progressPercentage: 50,
    status: "Pending Approvals" as any,
    executionBatches: [],
    executionLines: [
      {
        id: "EL008",
        workOrderLineId: "WOL008",
        lineNumber: "001",
        taskTitle: "Structural Assessment",
        taskDescription: "Complete structural integrity assessment", 
        approvedQuantity: 1,
        executedQuantity: 1,
        cumulativeExecuted: 1,
        remainingQuantity: 0,
        workCompletionPercentage: 100,
        rate: 250000,
        executedValue: 250000,
        uom: "Job",
        remarks: "Assessment completed, report submitted for approval",
        status: "Completed"
      },
      {
        id: "EL009",
        workOrderLineId: "WOL009", 
        lineNumber: "002",
        taskTitle: "Concrete Repairs",
        taskDescription: "Concrete crack repairs and reinforcement",
        approvedQuantity: 500,
        executedQuantity: 250,
        cumulativeExecuted: 250,
        remainingQuantity: 250,
        workCompletionPercentage: 50,
        rate: 1200,
        executedValue: 300000,
        uom: "Sqft",
        remarks: "Work in progress, awaiting approval for next phase",
        status: "In Progress"
      }
    ],
    createdAt: "2025-08-10T12:00:00Z",
    createdBy: "David Brown",
    updatedAt: "2025-08-22T17:30:00Z",
    lastExecutionDate: "2025-08-21",
    lastExecutionUpdate: "2025-08-22T16:45:00Z"
  }
];

// Mock Execution Batch Data  
export const mockExecutionBatchData: ExecutionBatch[] = [
  {
    id: "EB001",
    batchNumber: "EB/2024/001",
    workOrderId: "WO001",
    executionPeriodFrom: "2024-08-01",
    executionPeriodTo: "2024-08-15",
    totalExecutedValue: 750000,
    progressPercentage: 15,
    status: ExecutionBatchStatus.Submitted,
    submittedBy: "Site Engineer A",
    submittedAt: "2024-08-16T10:30:00Z",
    notes: "Completed foundation work for Block A",
    attachments: [],
    executionLines: [],
    approvalHistory: [
      {
        action: "Submitted for Approval",
        actionBy: "Site Engineer A",
        actionDate: "2024-08-16T10:30:00Z",
        role: ExecutionUserRole.SiteEngineer,
        status: ExecutionBatchStatus.Submitted
      }
    ]
  },
  {
    id: "EB002",
    batchNumber: "EB/2024/002", 
    workOrderId: "WO001",
    executionPeriodFrom: "2024-07-15",
    executionPeriodTo: "2024-07-31",
    totalExecutedValue: 500000,
    progressPercentage: 10,
    status: ExecutionBatchStatus.Approved,
    submittedBy: "Site Engineer A",
    submittedAt: "2024-08-01T09:15:00Z",
    approvedBy: "Project Manager",
    approvedAt: "2024-08-03T14:20:00Z",
    notes: "Initial excavation and site preparation completed",
    attachments: [],
    executionLines: [],
    approvalHistory: [
      {
        action: "Submitted for Approval", 
        actionBy: "Site Engineer A",
        actionDate: "2024-08-01T09:15:00Z",
        role: ExecutionUserRole.SiteEngineer,
        status: ExecutionBatchStatus.Submitted
      },
      {
        action: "Approved",
        actionBy: "Project Manager",
        actionDate: "2024-08-03T14:20:00Z", 
        role: ExecutionUserRole.Approver,
        status: ExecutionBatchStatus.Approved,
        comments: "Work completed as per specifications"
      }
    ]
  },
  {
    id: "EB003",
    batchNumber: "EB/2024/003",
    workOrderId: "WO002",
    executionPeriodFrom: "2024-08-10",
    executionPeriodTo: "2024-08-20",
    totalExecutedValue: 300000,
    progressPercentage: 20,
    status: ExecutionBatchStatus.UnderReview,
    submittedBy: "Electrical Engineer",
    submittedAt: "2024-08-21T11:45:00Z",
    notes: "Electrical panel installation completed",
    attachments: [],
    executionLines: [],
    approvalHistory: [
      {
        action: "Submitted for Approval",
        actionBy: "Electrical Engineer", 
        actionDate: "2024-08-21T11:45:00Z",
        role: ExecutionUserRole.SiteEngineer,
        status: ExecutionBatchStatus.Submitted
      },
      {
        action: "Under Review",
        actionBy: "Technical Reviewer",
        actionDate: "2024-08-22T09:30:00Z",
        role: ExecutionUserRole.Checker,
        status: ExecutionBatchStatus.UnderReview
      }
    ]
  }
];

// Mock Widget Data for Work Executions
export const mockWorkExecutionWidgetData: WorkExecutionWidgetData = {
  totalWorkExecutions: 5,
  notStartedCount: 1,
  notStartedPercentage: 20,
  inProgressCount: 1,
  inProgressPercentage: 20,
  onHoldCount: 1,
  onHoldPercentage: 20,
  completedCount: 1,
  completedPercentage: 20,
  closedCount: 1,
  closedPercentage: 20,
  cancelledCount: 0,
  cancelledPercentage: 0,
  totalWorkExecutionValue: 12800000,
  executedToDate: 6425000,
  pendingExecution: 6375000,
  avgProgressPercentage: 60,
  avgTimeForCompletion: 120
};

// Mock Widget Data for Execution Batches
export const mockExecutionBatchWidgetData: ExecutionBatchWidgetData = {
  totalBatches: 3,
  draftCount: 0,
  draftPercentage: 0,
  submittedCount: 1,
  submittedPercentage: 33.3,
  underReviewCount: 1,
  underReviewPercentage: 33.3,
  approvedCount: 1,
  approvedPercentage: 33.3,
  rejectedCount: 0,
  rejectedPercentage: 0,
  avgApprovalTime: 2.5,
  avgBatchValue: 516667,
  totalBatchValue: 1550000
};

// Mock Master Data Options
export const mockWorkExecutionStatusOptions = [
  { label: "Not Started", value: WorkExecutionStatus.NotStarted },
  { label: "In Progress", value: WorkExecutionStatus.InProgress },
  { label: "On Hold", value: WorkExecutionStatus.OnHold },
  { label: "Completed", value: WorkExecutionStatus.Completed },
  { label: "Closed", value: WorkExecutionStatus.Closed },
  { label: "Cancelled", value: WorkExecutionStatus.Cancelled }
];

export const mockExecutionBatchStatusOptions = [
  { label: "Draft", value: ExecutionBatchStatus.Draft },
  { label: "Submitted for Approval", value: ExecutionBatchStatus.Submitted },
  { label: "Under Review", value: ExecutionBatchStatus.UnderReview },
  { label: "Approved", value: ExecutionBatchStatus.Approved },
  { label: "Rejected", value: ExecutionBatchStatus.Rejected },
  { label: "Returned for Correction", value: ExecutionBatchStatus.ReturnedForCorrection }
];

export const mockContractorOptions = [
  { label: "ABC Construction Company", value: "C001" },
  { label: "XYZ Electrical Services", value: "C002" },
  { label: "PQR Plumbing Solutions", value: "C003" },
  { label: "Cool Air Systems Ltd", value: "C004" },
  { label: "Maintenance Pro Services", value: "C005" }
];

export const mockContractTypeOptions = [
  { label: "Construction Work", value: "Construction Work" },
  { label: "Service", value: "Service" },
  { label: "Maintenance", value: "Maintenance" },
  { label: "Others", value: "Others" }
];

export const mockSiteOptions = [
  { label: "Bangalore Construction Site", value: "S001" },
  { label: "Mumbai Industrial Site", value: "S002" },
  { label: "Delhi Office Complex", value: "S003" }
];

export const mockWorkOrderOwnerOptions = [
  { label: "John Doe", value: "John Doe" },
  { label: "Jane Smith", value: "Jane Smith" },
  { label: "Mike Johnson", value: "Mike Johnson" },
  { label: "Sarah Wilson", value: "Sarah Wilson" },
  { label: "David Brown", value: "David Brown" }
];